namespace SPA
{
	export namespace Guide
	{
		export interface IGuideItemOption
		{
			label:          ui.base.BaseHTMLElement | string;
			border:         ui.type.IBorderSetting;
			mode?:          "view" | "new";
			description?:   ui.base.BaseHTMLElement | string;
		}

		export class GuideItem extends ui.base.BaseHTMLElement
		{
			private m_Option:   IGuideItemOption;
			private m_Content:  GuideContent;
			private m_Panel:    GuidePanel | null;
			private m_Index:    number;

			public constructor( option: IGuideItemOption, content: GuideContent, private m_Jumpable: boolean = true )
			{
				super( 'guide-item' );

				this.m_Option   = option;
				this.m_Content  = content;
				this.m_Panel    = null;
				this.m_Index    = -1;
			}

			public setPanel( panel: GuidePanel, myIndex: number ): GuideItem
			{
				this.m_Panel	= panel;
				this.m_Index	= myIndex;

				this.m_Content.setPanel( panel );

				return this;
			}

			public rebuild( root: ui.base.BaseHTMLElement ): GuideItem
			{
				this.empty();
				this.remove();

				this.appendTo( root );

				this.addClass( 'not-selectable' );

				if ( this.m_Jumpable )
				{
					this.css(
						{
							cursor: 'pointer'
						}
					);
				}

				this.on(
					{
						click: () =>
						{
							if ( this.m_Panel === null || ( !this.m_Jumpable && false ) )
							{
								return;
							}

							this.m_Panel.moveTo( this.m_Index );
						}
					}
				);

				this.build();

				return this;
			}

			public show( root: ui.base.BaseHTMLElement ): void
			{
				this.m_Content.rebuild( root );
			}

			public hide(): void
			{
				this.m_Content.remove();
			}

			private build(): void
			{
				new ui.base.BaseHTMLElement( 'label' ).append( this.m_Option.label )
					.css(
						{
							'border': this.m_Option.border.width + ' ' + this.m_Option.border.style + ' ' + this.m_Option.border.color,
							'border-radius': this.m_Option.border.radius,
							'color': this.m_Option.border.color
						}
					)
				.appendTo( this );

				if ( this.m_Option.description )
				{
					new ui.base.BaseHTMLElement( 'label-description' )
						.append( this.m_Option.description )
					.appendTo( this );
				}
			}

		}
	}
}
